import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { VoiceInboundComponent } from './voice-inbound.component';
import { Modules, VoiceModules, Pages } from '../core/constants/shared.constants';
import { SharedModule } from '../shared/shared.module';

const routes: Routes = [
  {
    path: 'overview',
    component: VoiceInboundComponent,
    loadChildren: () => import('../voice-inbound/dashboard/dashboard.module').then(mod => mod.DashboardModule),
    data: {
      module: Modules.VoiceIn,
      menuTitle: VoiceModules.VoiceIn
    }
  },
  {
    path: 'application-phone',
    component: VoiceInboundComponent,
    loadChildren: () => import('../voice-inbound/application-phone/application-phone.module').then(mod => mod.ApplicationPhoneModule),
    data: {
      module: Modules.VoiceIn,
      menuTitle: VoiceModules.ApplicationPhone
    }
  },
  {
    path: 'channel-behavior',
    component: VoiceInboundComponent,
    loadChildren: () => import('../voice-inbound/channel-behavior/channel-behavior.module').then(mod => mod.ChannelBehaviorModule),
    data: {
      module: Modules.VoiceIn,
      menuTitle: VoiceModules.ChannelBehavior
    }
  },

  {
    path: 'did',
    component: VoiceInboundComponent,
    loadChildren: () => import('../voice-inbound/did/did.module').then(mod => mod.DidModule),
    data: {
      module: Modules.VoiceIn,
      menuTitle: VoiceModules.VoiceIn
    }
  },
  {
    path: 'inbound-history',
    component: VoiceInboundComponent,
    loadChildren: () => import('../voice-inbound/inbound-history/inbound-history.module').then(mod => mod.InboundHistoryModule),
    data: {
      module: Modules.VoiceIn,
      menuTitleTitle: VoiceModules.InboundHistory
    }
  },
  {
    path: Pages.StorageDetails,
    component: VoiceInboundComponent,
    loadChildren: () => import('../voice-inbound/storage-details/storage-details.module').then(mod => mod.StorageDetailsModule),
    data: {
      module: Modules.VoiceIn,
      menuTitleTitle: VoiceModules.Storage
    }
  },
  {
    path: Pages.RephraseInstructions,
    component: VoiceInboundComponent,
    loadChildren: () => import('../voice-inbound/rephrase-instructions/rephrase-instructions-voice-in.module').then(mod => mod.RephraseInstructionsVoiceInboundModule),
    data: {
      module: Modules.VoiceIn,
      menuTitleTitle: VoiceModules.RephraseInstructions
    }
  },
  {
    path: '',
    redirectTo: 'overview'
  },
  {
    path: '**',
    redirectTo: 'overview'
  }
];


@NgModule({
  declarations: [VoiceInboundComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    VoiceInboundComponent,
    RouterModule
  ]
})
export class VoiceInboundRoutingModule { }
